import PropTypes from 'prop-types'
import React, {useContext} from 'react'
import {CustomerDialogButtonRow as DialogButtonRow} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'
import {Context as FileUploadContext} from '@modifi/plugin-documents'

import {UploadDocumentsDialogContext} from '../../context'

const UploadCtaRow = ({withCancel, onCancel, onSubmit, inProgress, expectedSubmitDuration}) => {
  const {t} = useTranslation('moneta')
  const {filesToBeDeleted, filesToUpdate} = useContext(UploadDocumentsDialogContext)
  const {onClearUploadQueue, canPerformUpload, onPerformUpload, isUploading} =
    useContext(FileUploadContext)

  const handleCancel = () => {
    onClearUploadQueue()
    onCancel && onCancel()
  }

  const handleSubmit = async () => {
    if (canPerformUpload) {
      await onPerformUpload()
    }
    onSubmit && (await onSubmit())
  }

  let ctaActionIdent = 'cta-submit'
  if ((canPerformUpload || isUploading) && filesToBeDeleted.length > 0) {
    ctaActionIdent = 'cta-upload-and-remove'
  } else if (canPerformUpload) {
    ctaActionIdent = 'cta-upload'
  } else if (filesToBeDeleted.length > 0) {
    ctaActionIdent = 'cta-remove'
  } else if (filesToUpdate > 0) {
    ctaActionIdent = 'cta-update'
  }

  return (
    <DialogButtonRow
      canSubmit={
        (canPerformUpload && !isUploading) ||
        (filesToBeDeleted.length > 0 && !inProgress) ||
        (filesToUpdate > 0 && !inProgress)
      }
      expectedSubmitDuration={expectedSubmitDuration}
      loading={isUploading || inProgress}
      hasCancel={withCancel}
      canCancel={!isUploading && !inProgress}
      onCancelClick={handleCancel}
      onSubmitClick={handleSubmit}
      submitText={t(`dialog.upload-documents.${ctaActionIdent}`)}
    />
  )
}

UploadCtaRow.propTypes = {
  inProgress: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  withCancel: PropTypes.bool.isRequired,
  expectedSubmitDuration: PropTypes.number,
}

UploadCtaRow.defaultProps = {
  expectedSubmitDuration: 1,
}

export default UploadCtaRow
